import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject } from 'rxjs';
import { ViewLayoutModel } from '../../models/view-layout.model';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { takeUntil } from 'rxjs/operators';
import { ViewBreakpoint } from '../../models/view-breakpoint.enum';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';

@Component({
  selector: 'app-view-logo',
  templateUrl: './view-logo.component.html',
  styleUrls: ['./view-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewLogoComponent implements OnInit, OnDestroy {
  @Select(ViewState.getLayout)
  layout$: Observable<ViewLayoutModel>;

  @Select(StoryChaptersState.getSelectedChapterBackground)
  background$: Observable<BackgroundModel>;

  @Select(ViewState.getBreakpoint)
  breakpoint$: Observable<ViewBreakpoint>;

  isLight = true;
  viewBreakpoint = ViewBreakpoint;
  ngUnsubscribe = new Subject();
  
  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.background$.pipe(
      takeUntil(
        this.ngUnsubscribe
      )
    ).subscribe(background => {
      this.updateLogoColor(background);
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  updateLogoColor(background) {
    if (!background.colors) {
      return;
    }

    const outerRGB = background.colors.slice(0, 3);
    this.isLight = ColorUtils.isLight(outerRGB);
    this.changeDetectorRef.markForCheck();
  }

}
